module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_photographer@2x-a2a2f64a303fe60869a05946c1c46470.webp";